import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Link from 'app/components/common/link';
import paths from 'app/paths';
import helpers from 'app/helpers/grant-system';
import cdn from 'app/helpers/cdn';
import ClientTimestamp from 'app/components/common/client-timestamp';
import format from 'app/helpers/format';

const {ProgramStatuses} = helpers;

class ProgramCard extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {program, stats, isAdmin, company} = this.props;
    const status = (program.publishStatus === 'active')
      ? helpers.getProgramStatus(program)
      : program.publishStatus;
    const openDate  = program.openDateStr  ? <ClientTimestamp timestamp={program.openTs} />  : null;
    const closeDate = program.closeDateStr ? <ClientTimestamp timestamp={program.closeTs} /> : null;
    const statusMsg = (() => {
      if (status === ProgramStatuses.ACTIVE) {
        return closeDate
          ? <>Accepting applications until {closeDate}.</>
          : <>Now accepting applications.</>;
      }
      if (status === ProgramStatuses.ENDED) {
        return <>No longer accepting applications.</>;
      }
      if (status === ProgramStatuses.UPCOMING) {
        return openDate
          ? <>Open for applications on {openDate}.</>
          : null;
      }
    })();
    const path = isAdmin ? paths.cadminGrantProgram(company.slug, program.id) : paths.grantProgram(program.id);

    return (
      <Link href={path} className="prog-card">
        <div className="prog-card-img-con">
          {!!program?.imgPath && <img src={cdn.imgUrl(program.imgPath, {width: 780})} alt={program.title} className="prog-card-img" />}
          {/* <img src="https://t4.ftcdn.net/jpg/07/16/72/37/360_F_716723720_9FtIs2rQPBDfU8SfO2GF2n5iW1NGPbHU.jpg" alt={program.title} className="prog-card-img" /> */}
        </div>
        <div className="prog-card-main">
          <span className={`prog-card-main-status-chip ${status}`}>{status}</span>
          <div className="prog-card-main-title">{program.title}</div>
          <div className="prog-card-main-status">
            <span className="prog-card-main-status-msg">{statusMsg}</span>
          </div>
        </div>
        {!!stats && (
          <div className="prog-card-stats">
            <div className="prog-card-stats-row">
              <div className={`prog-card-stats-row-label purple ${!!stats.pendingAppCount ? 'present' : ''}`}>In Review</div>
              <div className={`prog-card-stats-row-val purple ${!!stats.pendingAppCount ? 'present' : ''}`}>{stats.pendingAppCount}</div>
              {/* <div className="prog-card-stats-row-val">{stats.pendingAppCount} {format.pluralize('app', stats.pendingAppCount)}</div> */}
              {/* <div className="prog-card-stats-row-val">{format.usd(stats.requestedAmount, 'round')}</div> */}
            </div>
            <div className="prog-card-stats-row">
              <div className={`prog-card-stats-row-label green ${!!stats.approvedAppCount ? 'present' : ''}`}>Approved</div>
              <div className={`prog-card-stats-row-val green ${!!stats.approvedAppCount ? 'present' : ''}`}>{stats.approvedAppCount}</div>
              {/* <div className="prog-card-stats-row-val">{stats.approvedAppCount} {format.pluralize('app', stats.approvedAppCount)}</div> */}
              {/* <div className="prog-card-stats-row-val">{format.usd(stats.approvedAmount, 'round')}</div> */}
            </div>
          </div>
        )}
      </Link>
    );
  }

}

ProgramCard.propTypes = {
  program: PropTypes.object.isRequired,
  company: PropTypes.object,
  stats: PropTypes.object,
  isAdmin: PropTypes.bool,
};

ProgramCard.defaultProps = {
  isAdmin: false,
};

export default ProgramCard;
